/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { UrlHelper } from '@env/url-helper';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string;

  constructor(@Inject(UrlHelper) urlHelper: UrlHelper){
    this.rootUrl = urlHelper.apiUrl;
  }
}

/**
 * Parameters for `ApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
